import { render, staticRenderFns } from "./CircuitoNotasInfantilPage.vue?vue&type=template&id=3dfe462e"
import script from "./CircuitoNotasInfantilPage.vue?vue&type=script&lang=js"
export * from "./CircuitoNotasInfantilPage.vue?vue&type=script&lang=js"
import style0 from "./CircuitoNotasInfantilPage.vue?vue&type=style&index=0&id=3dfe462e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports